import { createSelector } from '@reduxjs/toolkit';
import { meetingsNotDeleted } from './meetings-not-deleted';
import { employeeInterviewTemplateId } from '../templates';

export const employeeInterview = createSelector(meetingsNotDeleted, function (meetings) {
  return meetings.filter(function (item) {
    return item.templateId === employeeInterviewTemplateId;
  })[0];
});
